import router from '../../router'
import {mixin as clickaway} from 'vue-clickaway'
import InputButton from '../input-button/InputButton'
import InputText from '../input-text/InputText'
import InputTextArea from '../input-text-area/InputTextArea'
import {EntityBooking, EntityOption} from '../../services/entity.service'
import {Confirm} from '../../services/api.service'
import {SMS} from '../../services/notification.service'
import {Account} from "../..//services/account.service";
import {CustomerService} from "@/services/customer.service";
import {Location} from '@/services/location.service'
import InputDatePicker from "../input-date-picker/InputDatePicker";
import {BookingExport} from "@/services/bookingExport.service";
import {Constants} from "@/constants";
import InputCheckbox from "../input-checkbox/InputCheckbox"
import InputDropdown from "../input-dropdown/InputDropdown";
import {GroupDropdown} from "@/services/group.service";
export default {
    name: 'Card',
    computed: {
        GroupDropdown() {
            return GroupDropdown
        },

        sortedSpots () {
            return this.selectedGroup?.spots?.sort((a,b) => {
                return a.label.localeCompare(b.label)
            })
        }
    },
    mixins: [clickaway],
    components: {
        InputDropdown,
        InputCheckbox,
        InputButton,
        InputText,
        InputTextArea,
        InputDatePicker
    },

    props: {
        booking: undefined,
        confirm: undefined,
        reject: undefined,
        customerSettings: undefined,
        sms: undefined,
        entityOption: undefined,
        location: undefined,
        selectedDate:Date,
        legend: false,
        edit: Boolean,
        addNewFormulaFrom: [Number, String],
        addNewFormulaTo: [Number, String],
        addNewFormulaAddMinutes: Number,
        isRecurringBooking: Boolean
    },

    data() {
        return {
            customers: undefined,
            startDate: undefined,
            endDate : undefined,
            rejectionMessage: undefined,
            deleteSeries: false,
            selectedGroup: undefined,
        }
    },

    mounted() {
        this.edit = false
        this.startDate = this.startOfToday()
        this.endDate = this.endOfToday()
    },

    methods: {
        doCancel() {
            this.selectedGroup = undefined
            this.$emit('close')
        },

        doView() {
            router.push(`/booking/${this.booking.id}`)
        },

        doConfirm() {
            this.$emit('confirm')
        },

        doReject() {
            this.$emit('reject', {message: this.rejectionMessage, deleteSeries: this.deleteSeries})
        },

        toggleEdit() {
            this.edit = !this.edit
        },

        addNewFormula() {
            if (this.entityOption.timeSlotLengthFormulas != undefined) {
                this.entityOption.timeSlotLengthFormulas.push({
                    from: this.addNewFormulaFrom,
                    to: this.addNewFormulaTo,
                    addMinutes: this.addNewFormulaAddMinutes
                })
            } else {
                this.entityOption.timeSlotLengthFormulas = [{
                    from: this.addNewFormulaFrom,
                    to: this.addNewFormulaTo,
                    addMinutes: this.addNewFormulaAddMinutes
                }]
            }


            this.addNewFormulaFrom = undefined
            this.addNewFormulaTo = undefined
            this.addNewFormulaAddMinutes = undefined

        },

        removeFormula(formula) {
            this.entityOption.timeSlotLengthFormulas
                .splice(this.entityOption.timeSlotLengthFormulas
                    .indexOf(formula), 1)

        },

        updateStartDate(event) {
            this.startDate = event // moment(event).format('YYYY-MM-DD HH:mm:ss')
        },
        updateEndDate(event) {
            this.endDate = event //moment(event).format('YYYY-MM-DDTHH:mm:ss')
        },
        startOfToday() {
            if (this.selectedDate) {
                return new Date(this.selectedDate.getTime())
            }
            return new Date()
        },
        endOfToday() {
            if (this.selectedDate) {
                let endOfToday = new Date(this.selectedDate.getTime())
                endOfToday.setHours(23, 59, 0, 0)
                return endOfToday
            }
            let response = new Date()
            response.setHours(23, 59, 0, 0)
            return response
        },
        exportToExcel: async function() {
            try {
                await BookingExport.exportBookingsToExcel(this.location, new Date(this.startDate).toISOString(), new Date(this.endDate).toISOString())

            } catch(error) {

                this.$emit('close')
                await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: "404", message: "No bookings found"})

            }
        },

        toggleDeleteSeries() {
            this.deleteSeries = !this.deleteSeries
        },

        updateGroup(id) {
            const group = this.customerSettings.groups.find(g => g.id === id);
            this.selectedGroup = group
        },

        toggleSpot(id) {
            const spot = this.selectedGroup.spots?.find(s => s.id === id)
            const checked = this.customerSettings?.locationSpots?.find(s => s.id === spot.id)
            if (checked == undefined) {
                this.customerSettings.locationSpots?.push(spot)
            } else {
                this.customerSettings.locationSpots = this.customerSettings?.locationSpots?.filter(s => s.id !== spot.id)
            }
        },

        doSubmitCustomerSettings() {
            this.$emit('submitCustomerSettings', this.customerSettings)
        },

        toggleEntity(id) {
            const entity = this.selectedGroup?.entities?.find(e => e.id === id)
            const checked = this.customerSettings.location.entities.find(e => e.id === id)
            if (checked == undefined) {
                this.customerSettings.location.entities.push(entity)
            } else {
                this.customerSettings.location.entities = this.customerSettings?.location?.entities?.filter(e => e.id !== id)
            }
        },

        selectEntitySpot(spotId) {
            const checked = this.customerSettings.entity.spots.find(s => s.id === spotId)
            const spot = this.selectedGroup.spots?.find(s => s.id === spotId)
            if (checked == undefined) {
                this.customerSettings.entity.spots.push(spot)
            } else {
                this.customerSettings.entity.spots = this.customerSettings.entity.spots.filter(s => s.id !== spot.id)
            }
        }
    }
}
